import type { CustomFile } from '../file';

const FILE_PATTERN = /^(.*?)(\.[^.]+)?$/;

function checkFileNameExists(fileName: string, fileList: CustomFile[]) {
  return fileList.some(({ data }) => data.name === fileName);
}

function getIndexedFileName(name: string, index: number, extension: string) {
  return `${name}(${index})${extension}`;
}

export function getUniqueFileName(fileName: string, fileList: CustomFile[]) {
  if (!checkFileNameExists(fileName, fileList)) {
    return fileName;
  }

  const [name, extension] = fileName.match(FILE_PATTERN)?.slice(1) || [];

  let fileIndex = 1;
  let updatedFileName = getIndexedFileName(name, fileIndex, extension);

  while (checkFileNameExists(updatedFileName, fileList)) {
    fileIndex += 1;
    updatedFileName = getIndexedFileName(name, fileIndex, extension);
  }

  return updatedFileName;
}
